import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurytaxirentalinpune() {



  const cardData =
  {
    keyword: 'Luxury Taxi Rentals in Pune',
    heading: 'Aaryan Travels: Luxury Taxi Rentals in Pune',
    headingDescription: 'Aaryan Travels provides premium Luxury Taxi Rentals in Pune for corporate executives, VIP guests, weddings, and leisure travelers looking for style, comfort, and sophistication. Whether it’s an airport pickup from Pune International Airport, a business trip to Hinjewadi, or a luxury ride to Mahabaleshwar or Lonavala, our fleet of high-end sedans and SUVs—including Mercedes, BMW, and Innova Crysta—ensures a superior travel experience. With trained chauffeurs, spotless interiors, and on-request amenities like Wi-Fi and bottled water, Aaryan Travels delivers a first-class journey across Koregaon Park, Kalyani Nagar, Baner, and Magarpatta. Choose us for chauffeur-driven luxury taxi rentals in Pune that combine elegance with reliability.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light and sound show brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal artifacts and photographs. Its sprawling gardens and Italian arches make it a peaceful retreat. It also houses the samadhis of Kasturba Gandhi and Mahadev Desai. Aga Khan Palace is Pune’s symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for its charitable work. Devotees find immense peace and blessings here. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare laid down his life for Chhatrapati Shivaji Maharaj. Visitors trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking vistas of the Sahyadri ranges. Local vendors serve rustic pithla-bhakri meals near the top. Sinhagad is Pune’s perfect blend of history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single rock, it features a sanctum, monolithic pillars, and a Nandi pavilion. Despite being located on a busy road, the site offers a peaceful spiritual escape. Its ancient carvings showcase early Indian craftsmanship. Pataleshwar is Pune’s hidden gem of history and devotion."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar from across India. The exhibits include ornaments, musical instruments, pottery, sculptures, and household items from bygone eras. A highlight is the recreated Mastani Mahal, reflecting Maratha royal elegance. The museum fascinates students and historians alike. It is Pune’s treasure trove of art and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks offering panoramic views of the city. Visitors climb 103 stone steps to reach the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, the hill also houses smaller shrines and a museum. Sunrise and sunset views from the top are mesmerizing. Parvati Hill is Pune’s sacred and scenic viewpoint."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and wellness. Spread across serene gardens and minimalist architecture, it offers meditation sessions, yoga therapy, and rejuvenation programs. Visitors from around the world come for spiritual growth and relaxation. The tranquil ambience makes it ideal for self-reflection. Osho Ashram is Pune’s international retreat of mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, wooden gazebos, and manicured lawns. Families enjoy peaceful evening walks and photography amidst seasonal flowers. The garden beautifully blends Japanese aesthetics with Indian nature. It is Pune’s lush escape into serenity."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend spot within city limits. The scenic reservoir is surrounded by hills and greenery, especially vibrant during monsoon. Visitors enjoy roadside snacks like corn and tea while relaxing by the waterside. It also serves as the base point for trips to Sinhagad. Khadakwasla is Pune’s breezy retreat for unwinding."
  }
],



"services": [
  {
    "name": "Luxury Taxi Rentals in Pune",
    "description": "Luxury Taxi Rentals in Pune offer an unparalleled combination of comfort, sophistication, and professionalism for both corporate and personal travel. The service provides access to a fleet of high-end vehicles, including sedans, SUVs, and premium cars, each equipped with luxurious interiors, climate control, and safety features to ensure a smooth and enjoyable ride. Whether you're attending business meetings, corporate events, or special occasions, the chauffeurs are professionally trained to maintain punctuality, discretion, and courtesy. Available 24/7, Luxury Taxi Rentals in Pune also support flexible plans such as hourly, daily, and monthly bookings. The service emphasizes on-time pickups, immaculate car maintenance, and a customer-first approach that guarantees a world-class travel experience throughout the city."
  },
  {
    "name": "Premium Cab Services Pune",
    "description": "Premium Cab Services Pune specialize in offering high-quality travel experiences designed for executives, travelers, and families who seek superior comfort. Each cab is maintained to perfection, featuring plush interiors, complimentary amenities, and reliable Wi-Fi options. With trained chauffeurs who prioritize safety and professionalism, this service is perfect for airport transfers, client meetings, and leisure tours. It also offers customizable rental packages for both short-term and long-term needs, making it one of Pune’s most trusted premium mobility solutions."
  },
  {
    "name": "Chauffeur Driven Taxi Pune",
    "description": "Chauffeur Driven Taxi Pune delivers a refined and stress-free travel experience with skilled, courteous, and uniformed chauffeurs who are trained in corporate etiquette. The service is ideal for executives, VIP guests, and travelers who prefer to relax while being driven in style. With real-time tracking, route optimization, and on-time service, it combines the precision of professional transport with the comfort of luxury travel. Whether for daily commutes or one-time trips, every journey reflects reliability and class."
  },
  {
    "name": "Executive Cab Rental Pune",
    "description": "Executive Cab Rental Pune caters to corporate professionals and business travelers seeking elegant, comfortable, and time-efficient transport. Featuring an exclusive fleet of luxury sedans and SUVs, this service ensures smooth rides, professional drivers, and a first-class experience. It supports custom travel schedules and route planning to match the dynamic needs of modern executives. Perfect for airport pickups, client visits, or city meetings, this service redefines business travel in Pune."
  },
  {
    "name": "Luxury Car Hire Pune",
    "description": "Luxury Car Hire Pune provides access to top-tier cars from brands like BMW, Mercedes, and Audi for business, leisure, and events. Each car is maintained in showroom condition and comes with an experienced chauffeur for a premium ride experience. The service is ideal for weddings, VIP transfers, and special events where impression and comfort matter most. With flexible booking options and transparent pricing, it’s the go-to choice for luxury mobility in Pune."
  },
  {
    "name": "Business Class Taxi Pune",
    "description": "Business Class Taxi Pune focuses on executive-level travel solutions for professionals who value time, comfort, and class. Offering luxury sedans and SUVs equipped with modern amenities, this service ensures seamless travel between meetings, airports, and conferences. With features such as real-time GPS tracking, corporate billing, and chauffeur professionalism, it brings reliability and prestige to every journey."
  },
  {
    "name": "Affordable Luxury Taxi Pune",
    "description": "Affordable Luxury Taxi Pune delivers a perfect balance between cost-effectiveness and sophistication. Ideal for travelers who want premium rides at competitive rates, it offers luxurious vehicles and trained chauffeurs without exceeding budgets. The service is great for business executives, families, and event guests who expect high standards of comfort and punctuality."
  },
  {
    "name": "Wedding Taxi Hire Pune",
    "description": "Wedding Taxi Hire Pune provides beautifully maintained luxury taxis for wedding events, ensuring smooth transport for the bride, groom, and guests. Cars can be decorated according to themes, and professional chauffeurs manage all transfers with precision and elegance. The service ensures every ride on your special day reflects joy, class, and comfort."
  },
  {
    "name": "Corporate Luxury Taxi Pune",
    "description": "Corporate Luxury Taxi Pune is built to meet the needs of businesses seeking professional, stylish, and dependable transport for employees, executives, and clients. The fleet includes premium sedans and SUVs with experienced chauffeurs trained for corporate etiquette. Flexible monthly, quarterly, or yearly rental plans are available, ensuring consistent, high-quality mobility solutions for companies."
  },
  {
    "name": "Online Luxury Taxi Pune",
    "description": "Online Luxury Taxi Pune makes booking premium taxis simple, fast, and reliable through a convenient online interface. Users can select preferred car types, schedule rides, and receive instant confirmations. The platform supports corporate accounts, secure payments, and 24/7 customer assistance to ensure seamless service for all clients."
  },
  {
    "name": "High-End Taxi Services Pune",
    "description": "High-End Taxi Services Pune specialize in luxury transfers for executives, celebrities, and VIP clients. The fleet includes top-of-the-line vehicles equipped with advanced comfort and entertainment systems. Every chauffeur is well-groomed, punctual, and discreet, ensuring each journey is stress-free and of the highest professional standard."
  },
  {
    "name": "Best Luxury Taxi Pune",
    "description": "Best Luxury Taxi Pune offers an elite-level experience that combines refined comfort, efficient service, and elegant vehicles. Suitable for both business and leisure, this service ensures timely pickups, comfortable seating, and complete privacy. The brand is known for excellence in customer satisfaction and consistency in service quality."
  },
  {
    "name": "Prestige Taxi Pune",
    "description": "Prestige Taxi Pune represents a class above ordinary transport, providing a distinguished fleet and exceptional service quality. Designed for VIPs and corporate leaders, it ensures a stylish and safe journey every time. This service emphasizes punctuality, chauffeur professionalism, and comfort, making it the top choice for luxury travel in Pune."
  },
  {
    "name": "Pune Elite Taxi Rentals",
    "description": "Pune Elite Taxi Rentals focus on providing the city’s most exclusive luxury car rental experience. Featuring vehicles from Mercedes, Jaguar, and BMW, this service caters to high-profile clients and special occasions. The chauffeurs are specially trained to maintain high standards of professionalism, ensuring a flawless experience from booking to drop-off."
  },
  {
    "name": "Luxury SUV/Sedan Pune",
    "description": "Luxury SUV/Sedan Pune provides a diverse range of high-end SUVs and sedans for business and leisure. Whether you prefer the elegance of a sedan or the space and power of an SUV, this service ensures unmatched comfort, luxury, and style. It’s ideal for long-distance trips, city travel, or corporate use, supported by skilled drivers and flexible booking options."
  }
],
"tableData": [
  ["Luxury Taxi Rentals in Pune", "Premium Cab Services Pune"],
  ["Chauffeur Driven Taxi Pune", "Executive Cab Rental Pune"],
  ["Luxury Car Hire Pune", "Business Class Taxi Pune"],
  ["Affordable Luxury Taxi Pune", "Wedding Taxi Hire Pune"],
  ["Corporate Luxury Taxi Pune", "Online Luxury Taxi Pune"],
  ["High-End Taxi Services Pune", "Best Luxury Taxi Pune"],
  ["Prestige Taxi Pune", "Pune Elite Taxi Rentals"],
  ["Luxury SUV/Sedan Pune", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Taxi Rentals in Pune",
    "WhyChoosedescription": "Aaryan Travels offers top-notch luxury taxi rentals in Pune, ideal for business executives, weddings, airport transfers, and special events."
  },
  {
    "WhyChooseheading": "Premium Fleet of Luxury Vehicles",
    "WhyChoosedescription": "Choose from a wide range of high-end cars, including sedans and SUVs, for a classy and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs for Luxury Travel",
    "WhyChoosedescription": "Our trained, professional drivers ensure punctual, respectful, and smooth rides across Pune."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Taxis",
    "WhyChoosedescription": "Every vehicle is regularly cleaned and maintained to provide a safe and hygienic travel environment."
  },
  {
    "WhyChooseheading": "Clear, All-Inclusive Pricing",
    "WhyChoosedescription": "No hidden charges—our luxury taxi packages include fuel, tolls, and driver allowances for complete transparency."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available at all hours to assist with bookings, changes, or any urgent requirements."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Opt for hourly, daily, or customized rental packages tailored to your luxury travel needs."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service in Pune",
    "WhyChoosedescription": "We pride ourselves on timely pickups and drop-offs, making your luxury travel experience smooth and stress-free."
  }
]



























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury taxi rentals in Pune?',
    answer: 'Yes, Aaryan Travels offers premium luxury taxi rentals in Pune, ideal for business trips, special events, and personal travel.',
  },
  {
    question: 'How can I book luxury taxi rentals in Pune with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team in Pune.',
  },
  {
    question: 'What types of luxury vehicles are available for rental in Pune?',
    answer: 'Aaryan Travels provides a range of luxury vehicles including Mercedes-Benz, BMW, Audi, and high-end SUVs in Pune.',
  },
  {
    question: 'Are the drivers trained and experienced for luxury taxi services in Pune?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and dedicated to providing a top-tier travel experience.',
  },
  {
    question: 'Can I book luxury taxis in Pune for events and airport transfers?',
    answer: 'Yes, our luxury taxi rentals in Pune are perfect for airport pickups, weddings, corporate travel, and VIP transport.',
  },
  {
    question: 'Is the luxury taxi rental service in Pune available 24x7?',
    answer: 'Yes, Aaryan Travels provides round-the-clock luxury taxi services in Pune to meet your travel requirements anytime.',
  },
  {
    question: 'Are hygiene and safety protocols followed for luxury taxi rentals in Pune?',
    answer: 'All vehicles are thoroughly sanitized, and drivers adhere to strict safety and hygiene standards.',
  },
  {
    question: 'What payment options are accepted for luxury taxi rentals in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the luxury taxi rental period in Pune?',
    answer: 'Yes, our 24x7 customer support team is always available to assist you throughout your rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Abhishek Patil',
    feedback: 'Aaryan Travels provided an outstanding luxury taxi rental in Pune. The car was spotless and the service was exceptional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Deshmukh',
    feedback: 'Highly recommend Aaryan Travels for luxury taxi rentals in Pune. Great experience, professional driver, and a smooth ride.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const luxuryTaxiPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Taxi Rentals in Pune",
  "description": "Aaryan Travels offers premium luxury taxi rentals in Pune with professional chauffeurs and executive-class vehicles. Hire luxury sedans and SUVs for business trips, weddings, and personal travel at affordable prices.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Luxury Taxi Rentals",
  "keywords": "Luxury Taxi Rentals in Pune, Premium Cab Services Pune, Chauffeur Driven Taxi Pune, Executive Cab Rental Pune, Luxury Car Hire Pune, Business Class Taxi Pune, Affordable Luxury Taxi Pune, Wedding Taxi Hire Pune, Corporate Luxury Taxi Pune, Online Luxury Taxi Pune, High-End Taxi Services Pune, Best Luxury Taxi Pune, Prestige Taxi Pune, Pune Elite Taxi Rentals, Luxury SUV Sedan Pune"
};





  return (
    <div>


<Helmet>
  <title>Luxury Taxi Rentals in Pune | Premium & Executive Cab Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Book luxury taxi rentals in Pune with Aaryan Travels. Experience premium chauffeur-driven sedans and SUVs for weddings, business travel, and luxury trips at affordable prices."
  />
  <meta
    name="keywords"
    content="Luxury Taxi Rentals in Pune, Premium Cab Services Pune, Chauffeur Driven Taxi Pune, Executive Cab Rental Pune, Luxury Car Hire Pune, Business Class Taxi Pune, Affordable Luxury Taxi Pune, Wedding Taxi Hire Pune, Corporate Luxury Taxi Pune, Online Luxury Taxi Pune, High-End Taxi Services Pune, Best Luxury Taxi Pune, Prestige Taxi Pune, Pune Elite Taxi Rentals, Luxury SUV Sedan Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryTaxiPuneSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurytaxirentalinpune;